<template>
  <div>
    <b-button
      :type="actionType"
      class="filters-trigger"
      :class="{ 'has-count': count > 0 }"
      @click="isShownFilterModal = true"
    >
      <i :class="actionIcon" />
      {{ actionLabel }}
      <span
        v-if="count > 0"
        class="filters-count"
      >{{ count }}</span>
    </b-button>
    <transition name="slide-backdrop">
      <div
        v-show="isShownFilterModal"
        class="backdrop-side-modal"
        @click="isShownFilterModal = false"
      />
    </transition>
    <transition name="slide-fade">
      <div
        v-show="isShownFilterModal"
        class="side-modal"
      >
        <div class="is-border-bottom is-bg-white is-relative">
          <div
            class="px-5 py-3 is-flex is-align-items-center is-justify-content-space-between is-full"
          >
            <slot name="header" />
          </div>
        </div>
        <div class="side-modal-content">
          <slot />

          <div class="p-3">
            <slot name="footer" />
          </div>

          <!-- Pinned "Terminé" closes the panel (replaces the X) -->
          <div class="side-modal-done">
            <button
              type="button"
              class="button is-dark is-fullwidth"
              @click="isShownFilterModal = false"
            >
              {{ $t("done") }}
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    actionIcon: {
      default: "mdi mdi-filter",
      type: String,
    },
    actionLabel: {
      required: true,
      type: String,
    },
    count: {
      default: 0,
      type: Number,
    },
    actionType: {
      default: "button",
      type: String,
    },
  },
  data() {
    return {
      isShownFilterModal: false,
    };
  },
  methods: {
    onSuccess() {
      this.isShownFilterModal = false;
      this.$emit("success", true);
    },
    onClose() {
      this.isShownFilterModal = false;
    },
  },
};

/* <b-modal
      v-model="isShownFilterModal"
      :width="600"
      @success="onSuccess"
      @close="onClose"
    >
      <div class="modal-card">
        <header
          class="modal-card-head is-flex-direction-column is-flex is-align-items-flex-start"
        >
          <div
            class="is-flex is-full is-align-content-space-between"
            style="width: 100%"
          >
            <p class="modal-card-title title mb-0">
              {{ $t("filter") }}
            </p>
            <button class="delete" aria-label="close" @click="onClose" />
          </div>
        </header>

        <section class="modal-card-body">
          <slot />
        </section>
      </div>
    </b-modal> */
</script>

<style scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(100px);
  opacity: 0;
}

.slide-backdrop-enter-active {
  transition: all 0.3s ease;
}
.slide-backdrop-leave-active {
  transition: all 0.3s ease;
}
.slide-backdrop-enter,
.slide-fade-leave-to {
  opacity: 0;
}

.side-modal {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 99;
}
.side-modal-done {
  position: sticky;
  bottom: 0;
  padding: 12px;
  background: #fff;
  border-top: 1px solid #ececec;
}
.side-modal-content {
  background: #fff;
  padding: 10px;
  border-left: solid 1px #eee;
  border-top: solid 1px #eee;
  max-height: 100vh;
  overflow-y: scroll;
  position: relative;
  padding-bottom: 50px;
  min-height: 100vh;
}
.backdrop-side-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(15, 23, 42, 0.7);
  z-index: 9;
}
.is-border-bottom {
  border-bottom: 1px solid hsl(216, 12%, 84%);
}
.is-bg-white {
  background-color: #fff;
}
.btn-close-desktop {
  position: absolute;
  left: -60px;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  top: 9px;
  font-size: 34px;
  padding: 0;
  line-height: 30px;
  display: flex;
  justify-content: center;
  margin: 0;
  align-items: center;
  transition: all 0.2s linear;
  background: transparent;
  border: none;
  color: #fff;
}
.btn-close-desktop:hover {
  background: rgb(15, 23, 42, 0.9);
  transition: all 0.2s linear;
}
</style>
